<template>
    <div class="create-layout-wrapper">
        <h1>Layout erstellen</h1>
        <LayoutForm v-model="model"></LayoutForm>
        <AdaButton style="width: 100%" title="Layout erstellen" @click="createLayout" icon="icon-add"
                   type="fullWidthButton"></AdaButton>
    </div>
</template>

<script>

    import AdaButton from "../components/AdaButton";
    import {RepositoryFactory} from "../scripts/RepositoryFactory";
    import LayoutForm from "../components/LayoutForm";

    const LayoutRepository = RepositoryFactory.get('layouts');

    export default {
        name: "CreateLayout",
        components: {
            AdaButton,
            LayoutForm
        },
        data: function () {
            return {
                model: {
                    site: '',
                    question_font: 'Arial',
                    question_color: '#000000',
                    question_background: '#FFFFFF',
                    subtext_font: 'Arial',
                    subtext_color: '#000000',
                    subtext_background: '#FFFFFF',
                    scale_font: 'Arial',
                    scale_color: '#000000',
                    scale_background: '#FFFFFF',
                    container_background: '#FFFFFF'
                }
            }
        },
        computed: {},
        methods: {
            async createLayout() {
                try {
                    await LayoutRepository.createLayout(this.model);
                    await this.$router.push('/layouts');
                } catch (e) {
                    this.$noty.error("Fehler bei der Erstellung: \n" + e.response.data.error);
                }
            },
            randomHexColor() {
                let n = (Math.random() * 0xfffff * 1000000).toString(16);
                return '#' + n.slice(0, 6);
            }
        },
        mounted() {
        }
    }
</script>
<style lang="scss" scoped>

    .create-layout-wrapper {
        display: flex;
        align-items: center;
        flex-direction: column;
        width: 800px;
    }

    .create-form {
        width: 800px;
    }

    .create-form > div {
        margin-bottom: 20px;
    }

    .split-div {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

</style>